<div
    class="nw-card"
    [class.nw-card--multiple]="hasMultipleCards"
    [class.nw-card--disabled]="disabled"
    [class.nw-card--selected]="selected && toggleable && !disabled"
    role="region"
    (mousedown)="onClick($event)"
    (keydown.enter)="onClick($event)"
>
    <div class="nw-card__content">
        <ng-content select="[role=prefix]"></ng-content>
        <ng-content select="[role=header]"></ng-content>
        <ng-content select="[role=body]"></ng-content>
        <ng-content></ng-content>
    </div>
    @if (!disabled && !toggleable) {
        <nw-icon class="nw-card__chevron" aria-hidden="true" focusable="false">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill
                viewBox="0 0 13 22"
                height="100%"
                width="100%"
                style="display: block"
                preserveAspectRatio="xMidYMid meet"
                focusable="false"
            >
                <path
                    fill="currentColor"
                    d="M12.06 9.94a1.502 1.502 0 0 1 0 2.124l-9 9a1.502 1.502 0 0 1-2.124-2.123L8.876 11 .942 3.06A1.502 1.502 0 0 1 3.064.935l9 9-.005.005Z"
                />
            </svg>
        </nw-icon>
    }
    @if (!disabled && toggleable) {
        <nw-icon
            class="nw-card__circle"
            [class.nw-card__circle--selected]="selected"
            [icon]="selected ? 'circle-check' : 'circle'"
            aria-hidden="true"
            focusable="false"
        >
        </nw-icon>
    }
</div>
